import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
    NavigationLinkDirective,
    ShIconModule,
    ShNotificationComponent,
    ShPageHeaderComponent
} from '@stylehaven/components';
import { RejectionNotificationComponent } from './components/rejection-notification/rejection-notification.component';
import { RecordHeaderContainerComponent } from './containers/record-header/record-header-container.component';

import { RecordHeaderSandboxService } from './sandbox/record-header-sandbox.service';
import { BackToSearchNavigationCreator } from './service/back-to-search-navigation.creator';
import { PrevNextRecordNavigationItemCreator } from './service/prev-next-result-navigation-creator.service';

@NgModule({
    declarations: [RecordHeaderContainerComponent, RejectionNotificationComponent],
    imports: [
        TranslateModule,
        ShPageHeaderComponent,
        CommonModule,
        ShIconModule,
        ShNotificationComponent,
        NavigationLinkDirective,
        RouterModule
    ],
    exports: [RecordHeaderContainerComponent],
    providers: [RecordHeaderSandboxService, BackToSearchNavigationCreator, PrevNextRecordNavigationItemCreator]
})
export class RecordHeaderModule {}

export * from './entities/record-header-tab-item.entity';
export * from './entities/rejection-translations.entity';
export * from './sandbox/record-header-sandbox.service';
